import { useWindowSize } from 'react-use';

export const useScreenSizes = (): {
  mobile: boolean;
  tablet: boolean;
  desktop: boolean;
  largeScreen: boolean;
} => {
  const { width } = useWindowSize();
  return {
    mobile: width <= 360,
    tablet: width >= 361 && width <= 720,
    desktop: width >= 721 && width <= 1920,
    largeScreen: width >= 1921,
  };
};
